import { render } from "./CategoryIndex.vue?vue&type=template&id=5971e17d"
import script from "./CategoryIndex.vue?vue&type=script&lang=js"
export * from "./CategoryIndex.vue?vue&type=script&lang=js"

import "./CategoryIndex.vue?vue&type=style&index=0&id=5971e17d&lang=css"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__